export const MULTIPAGE_TESTING_GUIDE_STEPS_AMOUNT = 1;
